// Нууцлалын бодлого — нэвтрэлтгүй нээгдэнэ (App Store / Google Play-д заавал шаардлагатай URL). Томүжин апп ба портал хоёуланд хамаарна.
// Агуулгыг tas-app/store/privacy-policy.md-тэй ижил байлгана.
import React from "react";
import logo from "assets/images/logo.jpg";

const UPDATED = "2026-10-27";
const EMAIL = "info@tomujin.edu.mn";

function Section({ title, children }) {
  return (
    <section className="flex flex-col gap-2">
      <h2 className="text-lg font-extrabold text-[#5C1090] m-0">{title}</h2>
      <div className="text-[15px] leading-7 text-gray-800 flex flex-col gap-2">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <main className="min-h-screen bg-[#f1f2f6] py-8 px-4">
      <article className="max-w-3xl mx-auto bg-white rounded-2xl border border-[#E5D8F5] p-6 md:p-10 flex flex-col gap-7">
        <header className="flex flex-col gap-4">
          <img src={logo} alt="Tomujin Alternative School" className="h-12 w-auto self-start" />
          <div>
            <h1 className="text-2xl md:text-3xl font-extrabold text-[#5C1090] m-0">Нууцлалын бодлого</h1>
            <p className="text-sm text-gray-500 m-0 mt-1">Томүжин апп ба portal.tomujin.edu.mn · Шинэчилсэн: {UPDATED}</p>
          </div>
        </header>

        <Section title="Хэн, юуны тулд">
          <p className="m-0">Томүжин Альтернатив Сургууль (цаашид "сургууль") нь сурагч, эцэг эх, багш нарт зориулсан "Томүжин" гар утасны апп болон сурагч, эцэг эхийн порталыг ажиллуулдаг. Бүртгэлийг зөвхөн сургууль үүсгэнэ — апп-аас шинэ бүртгэл нээх боломжгүй.</p>
        </Section>

        <Section title="Цуглуулдаг мэдээлэл">
          <ul className="m-0 pl-5 flex flex-col gap-1 list-disc marker:text-[#5C1090]">
            <li>Нэр, и-мэйл, утасны дугаар, сурагчийн код, анги, бүлэг, хаус</li>
            <li>Ирц, хичээлийн хуваарь, дүн, шалгалт ба даалгаврын хариулт, тусгал</li>
            <li>Эцэг эхийн захидал, зөвшөөрлийн хуудас ба гарын үсэг, хийх зүйлсийн төлөв</li>
            <li>Төлбөрийн төлөв ба нэхэмжлэх (төлбөрийг банкны апп-аар QPay-ээр хийнэ; карт, дансны мэдээллийг бид хадгалдаггүй)</li>
            <li>Мэдэгдэл илгээх push token, апп-ын хэл ба горимын тохиргоо</li>
            <li>Камер — зөвхөн багш QR код уншуулж ирц бүртгэхэд, таны зөвшөөрлөөр; зураг хадгалагдахгүй</li>
          </ul>
        </Section>

        <Section title="Хэрхэн ашигладаг">
          <p className="m-0">Зөвхөн сургалт, сургуулийн үйл ажиллагаанд: ирц, дүн, хуваарь харуулах, эцэг эхтэй харилцах, мэдэгдэл илгээх, төлбөрийн мэдээлэл өгөх. Мэдээллийг зарахгүй, зар сурталчилгаанд ашиглахгүй, гуравдагч этгээдийн tracking эсвэл analytics хэрэгсэл ашигладаггүй.</p>
        </Section>

        <Section title="Хадгалалт ба хамгаалалт">
          <p className="m-0">Мэдээлэл сургуулийн серверт хадгалагдаж, HTTPS-ээр шифрлэгдэн дамжина. Зөвхөн эрх бүхий ажилтан, тухайн сурагчийн багш, эцэг эх харна. Push мэдэгдлийг Apple, Google-ийн мэдэгдлийн үйлчилгээгээр дамжуулна.</p>
        </Section>

        <Section title="Хүүхдийн мэдээлэл">
          <p className="m-0">Сурагчдын бүртгэлийг сургуульд элсэх үед эцэг эх, асран хамгаалагчийн мэдээлэлтэй хамт сургууль үүсгэнэ. Эцэг эх хүүхдийнхээ мэдээллийг үзэх, засуулах, устгуулах эрхтэй.</p>
        </Section>

        <Section title="Мэдээллээ устгуулах">
          <p className="m-0">Апп-ын Профайл → "Бүртгэл устгах хүсэлт" эсвэл <a href={`mailto:${EMAIL}`}>{EMAIL}</a> хаягаар хүсэлт илгээнэ. Хуулиар хадгалах шаардлагатай (жишээ нь төлбөр, сургалтын баримт) мэдээллээс бусдыг устгана.</p>
        </Section>

        <Section title="Холбоо барих">
          <p className="m-0">Томүжин Альтернатив Сургууль · <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
        </Section>

        <hr className="border-0 border-t border-[#E5D8F5] m-0" />

        <Section title="Privacy Policy (English)">
          <p className="m-0">Tomujin Alternative School operates the "Томүжин" (Tomujin) mobile app and the student/parent portal for its own students, parents and teachers. Accounts are created by the school only; there is no sign-up in the app.</p>
          <p className="m-0"><b>Data we collect:</b> name, email, phone, student code, grade, class and house; attendance, timetable, grades, exam and assignment answers, reflections; parent letters, consent forms and signatures; payment status and invoices (payments are made in banking apps via QPay — we never store card or bank details); push notification token; camera access only when a teacher scans a QR code for attendance (no photos are stored).</p>
          <p className="m-0"><b>Use:</b> school operations only — showing attendance, grades and schedules, parent–school communication, notifications and payment information. We do not sell data, show ads, or use third-party tracking or analytics.</p>
          <p className="m-0"><b>Storage:</b> on the school's servers, encrypted in transit (HTTPS); visible only to authorized staff, the student's teachers and their parents. Push notifications are delivered through Apple and Google push services.</p>
          <p className="m-0"><b>Deletion:</b> in the app go to Profile → "Бүртгэл устгах хүсэлт" (Request account deletion), or email <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. We delete all personal data except records we are legally required to keep (e.g. payment and academic records).</p>
          <p className="m-0"><b>Contact:</b> <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
        </Section>
      </article>
    </main>
  );
}
